import { render, staticRenderFns } from "./analyticsOfficialReplyWord.vue?vue&type=template&id=bbcab50e"
import script from "./analyticsOfficialReplyWord.vue?vue&type=script&lang=js"
export * from "./analyticsOfficialReplyWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports